export default "__VITE_ASSET__iZ7UEMrM__"